// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2ktkU","footer":"ModalFilter_footer__2u-_A"};